import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Tradesy'
        title='What You Need To Know About Tradesy Fees'
      >
        <p>
          If you’re just starting and want to venture into creating your shop on Tradesy. Now selling on Tradesy is
          simple. However, before you start, you need to familiarize yourself with the fees to sell on Tradesy. Like any
          online marketplace like Poshmark and eBay, they all have fees associated with their platforms.
        </p>
        <p>
          In this article, we’ll discuss what you need to know about navigating your way with Tradesy fees and just what
          is Tradesy’s fee structure all about.
        </p>

        <h3>How it works</h3>
        <p>
          When an item sells, sellers ship the item directly to the buyer, and the earnings will become pending once the
          tracking updates are available on the package. Don't worry if your earnings are not yet credited to your
          account after shipping. Tradesy may hold your earnings for up to 7 days after the delivery of the item buyer
          as part of security.
        </p>

        <h3>Receiving earnings</h3>
        <p>
          After the transaction has been completed, you can transfer your profit from your Tradesy account to your
          chosen checking account, Paypal, or debit card. You may also use the funds to buy something on Tradesy that
          you love or would like to add to your inventory.
        </p>

        <h3>What are Tradesy Fees?</h3>
        <p>
          Every seller should know what fees are involved in selling on their respective platforms, and Tradesy is no
          exception.{' '}
        </p>
        <p>Now, exactly how much are the fees on Tradesy? It depends on the type of fee.</p>
        <ul>
          <li>
            <h4>Commission Fee</h4>
            <p>
              From the beginning, we have the Tradesy commission fees. These are the standard fees that occur when items
              are sold. It charges $7.50 for sold items that are less than $50. If more, then the Tradesy fee increases
              to 19.8%.
            </p>
          </li>
          <li>
            <h4>Transfer Fees</h4>
            <p>
              When you receive your earnings, you have to pay the Tradesy transfer fee of 2.9% of the total amount. This
              transfer fee covers payment processing fees that Tradesy pays on your behalf when your items are sold.{' '}
            </p>
            <p>
              Now you might be wondering, “Can I avoid the transfer fee on Tradesy?” The answer is yes. The fee is
              automatically waived if you decide to spend your balance onTradesy.
            </p>
          </li>
          <li>
            <h4>Shipping Fees</h4>
            <p>
              It is no surprise that part of the selling fees on Tradesy is the shipping fee that is added to the sale
              price of each listed item. So in total, the shipping fee, plus the selling price assigned by the seller,
              is the total amount paid by the buyer. Tradesy retains the shipping fee and uses it to supplement the cost
              of providing pre-paid, insured Tradesy packaging and shipping kits to sellers.{' '}
            </p>
          </li>
        </ul>

        <h3>What is Tradesy Cash?</h3>
        <p>
          Your Tradesy Cash is the funds earned from sales plus the site credit from purchases processed as returns)
          they will automatically appear at checkout and be deducted from your order total. Whatever remains has no
          expiration date on your earnings. Also, by using your earnings to shop on Tradesy, you save on the 2.9%
          Transfer fee when you cash out your money.
        </p>
        <p>
          If you want to double your sales on Tradesy, one of the best ways done by top sellers is to sell on multiple
          marketplaces. The process is streamlined through the use of automation software.
        </p>
        <p>
          If you are looking for an innovative and customizable tool designed to act as your virtual assistant to gain
          an advantage over your competition and boost your sales, then OneShop is for you. It can effectively improve
          your sales by selling and cross-listing to multiple marketplaces like Tradesy and Poshmark. It also acts as
          your own sales expert. OneShop lists and re-list across multiple online marketplaces, which leaves you more
          time to work on more important things for your business rather than spending hours doing listings across
          platforms manually.
        </p>
        <p>Try it for yourself, register for free, and enjoy a 7-day trial with assistance from our team.</p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
